import { FileTextOutlined } from '@ant-design/icons';
import { Button, Card, Col, Row, Typography } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from 'src/config/route';

const { Title, Text } = Typography;

interface StaticPageEntry {
	slug: string;
	label: string;
	description: string;
	editPath: string;
}

const STATIC_PAGE_LIST: StaticPageEntry[] = [
	{
		slug: 'about-us',
		label: 'About Us',
		description: 'Hero section, story, values, timeline, editors, cities grid, and SEO.',
		editPath: ROUTES.EDIT_ABOUT_US.path,
	},
];

const StaticPages: React.FC = () => {
	return (
		<>
			<h1 className="sub-header">Static Pages</h1>
			<Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
				Manage region-specific content for static marketing pages. Each page is
				controlled per-region via the API.
			</Text>

			<Row gutter={[16, 16]}>
				{STATIC_PAGE_LIST.map((page) => (
					<Col key={page.slug} xs={24} md={12} lg={8}>
						<Card
							hoverable
							actions={[
								<Link key="edit" to={page.editPath}>
									<Button type="primary" className="btn-main save" size="small">
										Edit Content
									</Button>
								</Link>,
							]}
						>
							<Card.Meta
								avatar={<FileTextOutlined style={{ fontSize: 24, color: '#1890ff' }} />}
								title={<Title level={5} style={{ margin: 0 }}>{page.label}</Title>}
								description={<Text type="secondary">{page.description}</Text>}
							/>
						</Card>
					</Col>
				))}
			</Row>
		</>
	);
};

export default StaticPages;
